export default "__VITE_ASSET__B1ZyJ4_6__"